function toastError(error) {
  useToast({
    severity: 'error',
    summary: error?.data?.error || '오류', // error?.data?.error - 서버에 도달했지만 잘못된 URI로 요청했을 때 사용
    detail: error?.message, // https://app.asana.com/0/0/1204437917994745/1204428265402495/f
  })
}
export function fetchErrorHandler({ error, preventDefaultCatch }) {
  if (preventDefaultCatch) return Promise.reject(error)

  /*
   * jwt expired - Access Token 만료
   * jwt malformed - Refresh Token 만료
   */
  const jwtErrors = ['jwt expired', 'jwt malformed']
  if (!jwtErrors.includes(error.response?._data.message)) {
    /*
     * error.data가 사용되는 경우, API에 정상적으로 연결됐지만 결과값이 Error인 경우 - { success, data, message }
     * error가 사용되는 경우, 서버에 도달하지 못했거나, 서버엔 도달했지만 잘못된 URI로 요청했을 경우
     * jwt malformed - JWT토큰 만료 시, ToastMessage는 useRefreshToken에서 처리
     */
    const body = error?.data?.message ? error.data : error
    // errors(행별 오류 목록)가 있으면 토스트 대신 모달로 전체 목록을 보여준다 (ex. 엑셀 업로드 실패)
    if (body?.errors?.length)
      useErrorDialog().show({ message: body.message, errors: body.errors })
    else toastError(body)
  }

  console.error('🚀 ~ file: util.js:22 ~ fetchErrorHandler ~ error:', error)
}

export function scrollTop(options = { top: 0 }) {
  document.getElementsByClassName('main__container')[0]?.scrollTo(options) // header가 있는 경우
  document.getElementsByClassName('h-screen')[0]?.scrollTo(options) // header가 없는 경우. auth.factor !== 'requiredAccount'
}
